<template>
  <v-row>
    <v-col sm="6" offset-sm="3" xs="12" class="unauthorized-content">
      <v-alert type="error" :value="true">
        Je bent niet geautoriseerd om deze bron te openen.
      </v-alert>
    </v-col>
  </v-row>
</template>

<style scoped>
.unauthorized-content {
  text-align: center;
  padding-top: 16px;
}
</style>
